<div>
  <!-- TODO Check if H3 is correct here !-->
  <h3>Team verlaten</h3>

  <p>Om terug te keren in het team moet je worden uitgenodigd.</p>

  <parkour-button (clicked)="openTeamVerlatenModal()" class="block w-full mt-4" variant="tertiary">
    Team verlaten
    <parkour-icon name="login" />
  </parkour-button>
</div>
